import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	cancelButton: {
		id: 'admin-pages-priorities.priority-modals.delete-in-use-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Content for "Cancel" button in priority delete modal',
	},
	viewSchemesButton: {
		id: 'admin-pages-priorities.priority-modals.delete-in-use-modal.view-schemes-button',
		defaultMessage: 'View Schemes',
		description: 'Content for button to send user to priority schemes page',
	},
	deleteInUseModalBody: {
		id: 'admin-pages-priorities.priority-modals.delete-in-use-modal.delete-in-use-modal-body',
		defaultMessage:
			'To delete the priority "{priorityName}" you need to first remove it from {total} priority schemes',
		description: 'Message for modal to notify user that a priority is in use and cannot be deleted',
	},
	deleteInUseModalTitle: {
		id: 'admin-pages-priorities.priority-modals.delete-in-use-modal.delete-in-use-modal-title',
		defaultMessage: 'This priority is in use',
		description: 'Title for modal to notify user that a priority is in use and cannot be deleted',
	},
});
